import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
@Component({
  selector: 'app-condition-warranty-advance',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './condition-warranty-advance.component.html',
  styleUrl: './condition-warranty-advance.component.scss',
})
export class ConditionWarrantyAdvanceComponent {}
